export default "3dd21d4f0d28fecb.woff2"